import standardTypes from '../types/standard.js';
import Mime from './Mime.js';

export { default as Mime } from './Mime.js';

export default new Mime(standardTypes)._freeze();
